import React from "react";

const COLORS = {
  pending: { bg: "bg-zinc-100", text: "text-zinc-700", dot: "#71717A", border: "border-zinc-200" },
  in_transit: { bg: "bg-amber-50", text: "text-amber-700", dot: "#F59E0B", border: "border-amber-200" },
  ready_for_pickup: { bg: "bg-violet-50", text: "text-violet-700", dot: "#7C3AED", border: "border-violet-200" },
  delivered: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "#10B981", border: "border-emerald-200" },
  cancelled: { bg: "bg-red-50", text: "text-red-700", dot: "#EF4444", border: "border-red-200" },
  paid: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "#10B981", border: "border-emerald-200" },
  unpaid: { bg: "bg-amber-50", text: "text-amber-700", dot: "#F59E0B", border: "border-amber-200" },
  overdue: { bg: "bg-red-50", text: "text-red-700", dot: "#EF4444", border: "border-red-200" },
};

const LABELS = {
  pending: "Pending",
  in_transit: "In Transit",
  ready_for_pickup: "Ready for Pickup",
  delivered: "Delivered",
  cancelled: "Cancelled",
  paid: "Paid",
  unpaid: "Unpaid",
  overdue: "Overdue",
};

export default function StatusBadge({ status }) {
  const c = COLORS[status] || COLORS.pending;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border ${c.bg} ${c.text} ${c.border}`}
      data-testid={`status-${status}`}
    >
      <span className="status-dot" style={{ backgroundColor: c.dot }} />
      {LABELS[status] || status}
    </span>
  );
}
